import Vue from "vue";
import VueRouter from "vue-router";
Vue.use(VueRouter);
const first = [
    {
        path: "/login",
        component: () => import("@/views/Login"),
        name: "login",
        meta: {
            title: "登录",
        },
    },
    {
        path: "/shopCar",
        component: () => import("@/views/shopCar"),
        name: "shopCar",
        meta: {
            title: "购物车",
        },
    },
    {
        path: "/order",
        component: () => import("@/views/order"),
        name: "order",
        meta: {
            title: "订单管理",
        },
    },
    {
        path: "/",
        name: "Home",
        component: () => import("@/views/Home"),
        meta: {
            title: "首页",
        },
        // redirect: { name: "Category", params: { flbh: "", flmc: "全部" } },
        children: [
            {
                // path: "",
                path: "/Category/:flbh/:flmc",
                name: "Category",
                component: () => import("@/views/Category"),
                meta: {
                    title: "分类",
                },
            },

        ]
    },
    {
        path: "/Spinfo/:spxh",
        name: "Spinfo",
        component: () => import("@/views/Spinfo"),
        meta: {
            title: "商品信息",
        },
    }
];
// const error = {
//     path: "*",
//     component: () => import("@/views/Error"),
//     name: "404",
//     meta: {
//         title: "发生错误",
//     },
// };
const routes = [
    ...first,
    // error,
];
const router = new VueRouter({
    routes,
});
router.beforeEach((to, from, next) => {
    // 设置页面标题
    if (to.name === "Category") {
        to.meta.title = to.params.flmc || '全部';
    }
    if (to.name === "Spinfo") {
        to.meta.title = to.params.spmc || '';
    }

    // const dwinfo = JSON.parse(localStorage.getItem("dwinfo"))||{};

    next();
    // if (dwinfo) {
    //     next();
    // } else {
    //     next();
    // next({ path: "/Home" });
    // if (to.name === "login") {
    //     next();
    // } else {
    //     next({ path: "/login" });
    // }
    // }    
});

export default router;
